import { Tooltip } from '@afterpaytouch/core'
import React from 'react'
import { ModuleContainer } from '../ModuleContainer'
import { TooltipContent } from './TooltipContent'

interface ApplepayTooltipProps {
  tooltipShow: boolean
  id: string
  closeTooltip: () => void
}

export const ApplePayTooltip: React.FC<ApplepayTooltipProps> = ({ tooltipShow, id, closeTooltip }) => {
  if (!tooltipShow) {
    return null
  }

  return (
    <ModuleContainer nested key='apple-pay-learn-more-container' padding={{ horizontal: 'XLarge', bottom: 'Large' }}>
      <Tooltip testNameSpace='apple-pay' id={id} content={<TooltipContent />} usePortal={false} onClose={closeTooltip} />
    </ModuleContainer>
  )
}
